<template>
  <v-container>
    <h2>Introduction</h2>
    <p>
      This is a research study conducted by Northwestern University, titled
      "Listener perceptions of different stories and voices". The Principal
      Investigator is Annette D’Onofrio.
    </p>
    <h2>Instructions</h2>
    <p>
      As a participant in the experiment, you will be asked to complete a number
      of tasks:
    </p>
    <ul>
      <li>Carefully read and agree to a consent form</li>
      <li>Enter basic demographic information about yourself</li>
      <li>
        Complete and submit the experiment. You will be asked to listen an audio
        recording and answer some questions about what you heard
      </li>
    </ul>
    <h2 class="mt-4">Headphones</h2>
    <p>
      You will need to be in a quiet location and wear wired headphones for the
      duration of the experiment. Good quality wired headphones are recommended
      and preferred. You should plug your headphones directly to your computer
      and you should listen to the experimental trials at the most comfortable
      volume level for you. You may adjust the volume of your computer to be the
      most audible and comfortable one for you.
    </p>

    <v-btn @click="next">next <v-icon>chevron_right</v-icon></v-btn>
  </v-container>
</template>

<script>
import router from "@/router";
import store from "@/store";
export default {
  setup() {
    const next = () => {
      store.commit("setLocked", false);
      router.push("/consent");
    };

    return { next };
  },
};
</script>